import type { ContactUsConfig } from './types'
import { commonTexts } from './common'

/**
 * FicMoon 品牌 Contact Us 页面配置
 */
export const contactUsConfig: ContactUsConfig = {
  texts: commonTexts,
  colors: {
    bgPrimary: '#050000', // 主背景
    bgTertiary: '#1F1E20', // 卡片背景 (使用 newTheme.bgCard)
    textPrimary: '#FFFFFF', // 主要文本
    textTertiary: '#A5A5A5', // 三级文本
    textPlaceholder: '#A5A5A5', // 占位符文本
    accentRed: '#FC5549', // 红色强调
    primaryColor: '#FC542F', // 品牌主色
    whiteColor: '#FFFFFF', // 白色
  },
}
